<template>
    <div>
    <!--Bread Crumb Wrap Start-->
    <div class="kode_about_bg">
    	<div class="container">
        	<div class="kode_aboutus_wrap">
            	<h4>Data Chart Kependudukan</h4>
				<div class="kode_bread_crumb">
                	<ul>
                		<li><a href="/">Home</a></li>
                    	<li><router-link to="/data_agregat_kependudukan">Data Chart Kependudukan</router-link></li>
                	</ul>
                </div>
            </div>
        </div>
    </div>
    <!--Bread Crumb Wrap Start-->   
    
     
        
    <!--Content Wrap Start-->
    <div class="kode_content" style="padding-top:5%">
    	
        <!--News List Wrap Start-->
        <section >
        	<div class="container">
            	<div class="row">
                	<div class="col-md-8 kode_news_colmn_list">

                        <!-- Chart Section -->
                        <div class="kode_news_list" style="padding: 20px; background: #f9f9f9; border-radius: 5px; margin-bottom: 30px;">
                            <h5 class="text-center" style="margin-top: 0;"><b>Chart Kependudukan</b></h5>
                            <hr>
                            <div id="containerChart" style="height: 400px;"></div>
                            <!-- <highcharts :options="chartOptions"></highcharts>                         -->
                        </div>
                        <!-- Chart Section -->
                        
 
                        
                        
 
						<div class="clearfix clear"></div>
						<!--Pagination Wrap Start-->
						<!-- <div class="kode_pagination">
							<ul class="pagination">
                                    <div class="text-center">
										<button @click="btn_prev" type="button" class="btn " id="pref">
											<span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span>
										</button>
										&nbsp;
										<span style="font-size: 85%; color: #a5a5a5">
											<b>{{page_first}} - {{page_last}}</b>
										</span>
										&nbsp;
										<button @click="btn_next" type="button" class="btn" id="next">
											<span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span>
										</button>
									</div>
						
							</ul>
						</div> -->
						<!--Pagination Wrap End-->
                    </div>
                    
                    <div class="col-md-4">
                    <div class="kode_aside_event kode_aside">
                        	<h5>Pilih Indikator Chart</h5>
                        	<form>
                            	<select id="filter" v-model="selectedFilter" @change="onFilterChange" style="height: 58px;color: #a5a5a5;">
                                	<option value="">-- Pilih Indikator --</option>
                                	<option v-for="item in data_statistik" :key="item.kode_indikator" :value="item.kode_indikator">
                                    	{{ item.nama_indikator }}
                                	</option>
                            	</select>
                            </form>
                        </div>
                    	<!-- <div class="kode_aside_search">
                        	<form>
                            	<input id="search" type="text" placeholder="Search ..." @keyup="cari_data" v-model="cari_value">
                                <button><i class="fa fa-search"></i></button>
                            </form>
                        </div> -->
                        
 
                        
						<!--Aside Event Wrap Start-->
                        <div class="kode_aside_event kode_aside">
                        	<h5>Kegiatan</h5>
                            <ul>
                            	<li v-for="data in kegiatan" :key="data.id">
                                	<figure>
                                    	<img :src="file_path+data.foto" alt="Image Here">
                                        <figcaption>
                                         
                                            <a href="javascript:void(0);" @click="push_kegiatan(data.id)"><i class="fa fa-link"></i></a>
                                        </figcaption>
                                    </figure>
                                    <div class="kode_aside_event_des" style="text-align:justify">
                                    	<p v-html="limit_desk_kegiatan(data.deskripsi)+' ...'"> </p>
                                    	<span><b>{{convert_tgl(data.createAt)}}</b></span>
                                    </div>
                                </li>
                                
 
                            </ul>
                        </div>
                        <!--Aside Event Wrap End-->
						
 
                        
 
                        
						<!--Aside Flicker Wrap Start-->
                        <div class="kode_aside_flicker kode_aside">
                        	<h5>Galleri Kegiatan</h5>
                        	<ul>
                            	<li v-for="data in kegiatan6" :key="data.id">
                                	<a href="javascript:void(0);" @click="push_kegiatan(data.id)">
                                		<figure>
                                    		<img :src="file_path+data.foto" alt="Image Here" style="height:90px;width:100%">
                                            <figcaption>
                                            	<i class="fa fa-plus"> </i>
                                            </figcaption>
                                    	</figure>
                                	</a>
                                </li>
                                
 
                            </ul>
                        </div>
						<!--Aside Flicker Wrap End-->
                        
                    </div>
                    
                    
                </div> 

                <!-- Button trigger modal -->


                <!-- Modal -->
                <div class="modal fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" >
                <div class="modal-dialog modal-lg" role="document" >
                    <div class="modal-content" >
                    <div class="modal-header" >
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h6 class="modal-title" id="myModalLabel" ><small><b>LIHAT DATA</b></small></h6>
                    </div>
                    <div class="modal-body">

                         <h6><b> {{judul}} </b> </h6>
                        <hr>
                        <div class="text-center" v-if="file_tampil">
                            <embed :src="file_path+file" width="850" height="800" 
                            type="application/pdf">
                        </div>
                        <hr>
                        <p v-html="isi"></p>
                        
                    </div>
                    <div class="modal-footer" >
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-default" style="background-color:#ef4a2b;color:#fff">Download</button>
                    </div>
                    </div>
                </div>
                </div>

                
            </div>
        </section>
        <!--News List Wrap End-->
        
    </div>
    <!--Content Wrap End-->
    </div>
</template>



<script>

// Highcharts sudah dimuat dari CDN di index.html
// Gunakan window.Highcharts untuk mengakses library

// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import {ImageResize} from 'quill-image-resize-module'
// Quill.register('modules/imageResize', ImageResize)


// Quill.register("modules/imageResize", ImageResize);

const ADD_URL         = URL_APP + "api/v1/publish_data_kependudukan/";
const KEGIATAN_URL    = URL_APP + "api/v1/publish_kegiatan/";
const FILE_LOAD       = URL_APP + "uploads/";

import { Chart } from 'highcharts-vue'

export default {
  name: "web_pengumuman",
  components: {
    Highcharts: Chart
  },
  data() {
    return {
        file_tampil: false,
		id: "",
		id_berita :"",
		createAt : '',
		createBy : '',
		desk : '',
		isi : '',
		judul : '',
		sumber : '',
		foto : '',
		HOST : URL_HOST+'/isi_berita/',
		file_path: FILE_LOAD,
    
        kegiatan:[],
        kegiatan6:[],

		list_data: [],
		page_first: 1,
		page_last: 0,
		cari_value: "",
		selectedFilter: "",

		// Highcharts data
        chartOptions: {
            title: {
            text: 'My First Chart'
            },
            series: [{
            data: [1, 2, 3]
            }]
        },

        data_statistik:[],
    




    };
  },

  // =============================================================== METHODS =========================================================================
  // =============================================================== METHODS =========================================================================
  methods: {
    getDataStatistik: function() {
      fetch("https://data.konaweselatankab.go.id/api/public/dashboard?kode_opd=2.12.0.00.0.00.01.0000", {
        method: "GET",
        headers: {
          "content-type": "application/json",
        }
      })
        .then(res => res.json())
        .then(res_data => {
            console.log(res_data.data);
            this.data_statistik = res_data.data;
            // Set selected filter ke data pertama dan render chart
            if(this.data_statistik.length > 0) {
              this.selectedFilter = this.data_statistik[0].kode_indikator;
              this.updateChart(this.data_statistik[0]);
            }
        });
	},

    getView: function() {
      fetch(ADD_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
            // console.log(res_data);
        });
	},

    loadchart(){
        Highcharts.chart('containerChart', {
            chart: {
                type: 'column'
            },
            title: {
                text: 'Corn vs wheat estimated production for 2023'
            },
            subtitle: {
                text:
                    'Source: <a target="_blank" ' +
                    'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>'
            },
            xAxis: {
                categories: ['USA', 'China', 'Brazil', 'EU', 'Argentina', 'India'],
                crosshair: true,
                accessibility: {
                    description: 'Countries'
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: '1000 metric tons (MT)'
                }
            },
            tooltip: {
                valueSuffix: ' (1000 MT)'
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [
                {
                    name: 'Corn',
                    data: [387749, 280000, 129000, 64300, 54000, 34300]
                },
                {
                    name: 'Wheat',
                    data: [45321, 140000, 10000, 140500, 19500, 113500]
                }
            ]
        });

    },

	
    getOne: function() {
      fetch(ADD_URL + "getOne", {
        method: "get",
        headers: {
          "content-type": "application/json",
        },

      })
        .then(res => res.json())
        .then(res_data => {
        //   this.list_data = res_data.data;
        //   this.page_last = res_data.jml_data;
			// console.log(res_data);

            var berita = res_data[0];
            
            this.id_berita = berita.id;
            this.createAt = berita.createAt;
            this.createBy = berita.createBy;
            this.desk = berita.desk;
            this.isi = berita.isi;
            this.judul = berita.judul;
            this.sumber = berita.sumber;
            this.foto = berita.foto;    



        });
  },
  
    getKegiatan: function() {
        fetch(KEGIATAN_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan = res_data;
                //   console.log(res_data);
            });
    },    

    getKegiatan6: function() {
        fetch(KEGIATAN_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan6 = res_data;
                //   console.log(res_data);
            });
    },     

    limit_desk_kegiatan : function(text){
    return text.substring(0, 100)
    }, 

	push_kegiatan : function(id){
		this.$router.push('/isi_kegiatan/'+id);
    },
	
	push_berita : function(id){
		this.$router.push('/isi_berita/'+id);
	},

	to_facebook : function () {
        window.open("http://www.facebook.com/sharer.php?u="+this.HOST+this.id_berita, '_blank');
    },
    to_twitter : function(){
        // alert(this.HOST)
        window.open("https://twitter.com/share?url="+this.HOST+this.id_berita+"&amp;text="+this.judul, '_blank');
    },


    GetData: function(id, judul, desk, isi, file) {
      this.id = id;
      this.judul = judul;
      this.desk = desk;
      this.isi = isi; 

      this.file = file;
      this.file_old = file;


      if (file == '') {this.file_tampil = false;}
      else{this.file_tampil = true;}
      

    },



// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },

    // Generate warna random
    getRandomColor: function() {
      const colors = [
        '#ef4a2b', // Merah (default)
        '#FF6B6B', // Merah cerah
        '#4ECDC4', // Teal
        '#45B7D1', // Biru muda
        '#FFA07A', // Salmon
        '#98D8C8', // Hijau muda
        '#F7DC6F', // Kuning
        '#BB8FCE', // Ungu
        '#F8B88B', // Oranye
        '#85C1E2', // Biru
        '#F5B7B1', // Pink
        '#F9E79F'  // Kuning muda
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },

    onFilterChange: function() {
      console.log('Indikator dipilih:', this.selectedFilter);
      
      if(this.selectedFilter) {
        // Cari data berdasarkan kode_indikator yang dipilih
        let selectedData = this.data_statistik.find(item => item.kode_indikator === this.selectedFilter);
        
        if(selectedData) {
          console.log('Data indikator:', selectedData);
          this.updateChart(selectedData);
        }
      }
    },

    updateChart: function(data) {
      // Debug: Log data untuk melihat struktur
      console.log('Data untuk chart:', data);
      console.log('Years:', data.years);
      console.log('Values:', data.values);
      
      // Array warna untuk pilihan
      const colors = [
        '#ef4a2b', // Merah (default)
        '#FF6B6B', // Merah cerah
        '#4ECDC4', // Teal
        '#45B7D1', // Biru muda
        '#FFA07A', // Salmon
        '#98D8C8', // Hijau muda
        '#F7DC6F', // Kuning
        '#BB8FCE', // Ungu
        '#F8B88B', // Oranye
        '#85C1E2', // Biru
        '#F5B7B1', // Pink
        '#F9E79F'  // Kuning muda
      ];
      
      // Buat data dengan warna yang berbeda untuk setiap bar
      const dataWithColors = data.values.map((value, index) => {
        return {
          y: value,
          color: colors[index % colors.length] // Gunakan warna dari array sesuai index
        };
      });
      
      // Update chart dengan data baru
      Highcharts.chart('containerChart', {
        chart: {
          type: 'column'
        },
        title: {
          text: data.nama_indikator
        },
        subtitle: {
          text: 'Satuan: ' + data.satuan + ' | OPD: ' + data.nama_opd
        },
        xAxis: {
          categories: data.years,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: data.satuan
          }
        },
        tooltip: {
          valueSuffix: ' ' + data.satuan,
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            minPointLength: 3  // Tampilkan bar meskipun nilainya kecil/nol
          }
        },
        series: [
          {
            name: data.nama_indikator,
            data: dataWithColors,  // Gunakan data dengan warna berbeda untuk setiap bar
            dataLabels: {
              enabled: false
            }
          }
        ]
      });
    },

    convert_tgl : function(dateString){
		var date = new Date(dateString);
		var bulan = "";

		if (date.getMonth() == 0) {bulan = 'januari';} 
		else if (date.getMonth() == 1) {bulan = 'Februari';}
		else if (date.getMonth() == 2) {bulan = 'Maret';}
		else if (date.getMonth() == 3) {bulan = 'April';}
		else if (date.getMonth() == 4) {bulan = 'Mei';}
		else if (date.getMonth() == 5) {bulan = 'Juni';}
		else if (date.getMonth() == 6) {bulan = 'Juli';}
		else if (date.getMonth() == 7) {bulan = 'Agustus';}
		else if (date.getMonth() == 8) {bulan = 'September';}
		else if (date.getMonth() == 9) {bulan = 'Oktober';}
		else if (date.getMonth() == 10) {bulan = 'November';}
		else if (date.getMonth() == 11) {bulan = 'Desember';}
		else{bulan = ''}

		return date.getDate()+" "+bulan+" "+date.getFullYear();
	},

	// renderCharts: function() {
	// 	// Render chart pertama (Column Chart)
	// 	if(window.Highcharts) {
	// 		window.Highcharts.chart('chartContainer', this.chartOptions);
	// 	}
	// },

// ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
	this.getView();
	this.getOne();
    this.getKegiatan();
	this.getKegiatan6();
	// this.renderCharts();
    
	this.getDataStatistik();
  }
};
</script>

<style scoped>
/* Style untuk Select Filter & Input Search sama */
.kode_aside_search form {
  position: relative;
  display: flex;
  align-items: center;
}

.kode_aside_search input,
.kode_aside_search select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 14px;
  background-color: #fff;
  color: #333;
  font-family: inherit;
  transition: all 0.3s ease;
}

.kode_aside_search select {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 20px;
  padding-right: 35px;
}

.kode_aside_search input:hover,
.kode_aside_search select:hover {
  border-color: #999;
}

.kode_aside_search input:focus,
.kode_aside_search select:focus {
  outline: none;
  border-color: #ef4a2b;
  box-shadow: 0 0 5px rgba(239, 74, 43, 0.2);
}

.kode_aside_search button {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background: none;
  border: none;
  padding: 10px 12px;
  cursor: pointer;
  color: #ef4a2b;
  font-size: 14px;
  transition: all 0.3s ease;
}

.kode_aside_search button:hover {
  color: #d63a1f;
}

.kode_aside_search select option {
  padding: 8px;
  color: #333;
}

.kode_aside_search select option:checked {
  background: linear-gradient(#ef4a2b, #ef4a2b);
  background-color: #ef4a2b;
  color: white;
}

/* Margin untuk spacing antara form */
.kode_aside_search {
  margin-bottom: 15px;
}

.kode_aside_search:last-of-type {
  margin-bottom: 0;
}
</style>